import { useRouter } from "next/router";

import BootstrapDropdown from "react-bootstrap/Dropdown";

import { twMerge } from "tailwind-merge";

import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";

import FontAwesomeIcon from "components/FontAwesomeIcon";

import styles from "./styles.module.scss";

type Option = {
  id: string;
  name: string;
  [key: string]: any;
};

type DropdownProps = {
  options: Option[];
  defaultOption?: Option;
  queryParam?: string;
  onSelect?: (_option: Option) => void;
};

const Dropdown = ({
  options = [],
  defaultOption,
  queryParam,
  onSelect,
}: DropdownProps) => {
  const router = useRouter();
  const queryOption = queryParam && (router.query?.[queryParam] as string);

  const selectedOption =
    (queryOption ? options.find((o) => o.id === queryOption) : defaultOption) ||
    options[0];

  return (
    <span className={styles.dropdown}>
      <BootstrapDropdown>
        <BootstrapDropdown.Toggle variant="success">
          {selectedOption.name} <FontAwesomeIcon icon={faCaretDown} />
        </BootstrapDropdown.Toggle>

        <BootstrapDropdown.Menu className={styles.menu}>
          {options.map((item) => (
            <BootstrapDropdown.Item
              className={twMerge(
                styles.item,
                selectedOption.id === item?.id && styles.active
              )}
              key={item?.id}
              onClick={() => {
                if (onSelect) onSelect(item);
                if (queryParam) {
                  router.push(
                    {
                      pathname: router.pathname,
                      query: {
                        ...router.query,
                        [queryParam]: item.id,
                      },
                    },
                    undefined,
                    { shallow: true }
                  );
                }
              }}
            >
              {item?.name}
            </BootstrapDropdown.Item>
          ))}
        </BootstrapDropdown.Menu>
      </BootstrapDropdown>
    </span>
  );
};

export default Dropdown;
